export const environment = {
  production: false,
  urlServer: "https://colpraz.devwebsite.es/",
  urlWeb: "https://colpraz.devwebsite.es/",
  recaptcha: {
    siteKey: '6LcgzbAqAAAAAA7xcwrP6IPhxCnNGMfgjlBFK_bv'
  },
  nombre: 'staging',
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
  firebase: {
    apiKey: "AIzaSyD5Yzea5RWP4fi8XXDu24xDjPlWMBeuvCk",
    authDomain: "iguau-f05b9.firebaseapp.com",
    projectId: "iguau-f05b9",
    storageBucket: "iguau-f05b9.firebasestorage.app",
    messagingSenderId: "353336045860",
    appId: "1:353336045860:web:75f5575222540be74f03b1"
  }
};
